// extracted by mini-css-extract-plugin
module.exports = {"inputField":"sessionCaptureRate_inputField_3HlsyhK","customSlider":"sessionCaptureRate_customSlider_3RC8S_A"};